import CryptoJS from "crypto-js";

import AWS from 'aws-sdk';
// import { v4 as uuidv4 } from 'uuid'
 
 
AWS.config.update({
  secretkey: process.env.REACT_APP_CRYPTO_SECRET_KEY,
});
let SECRET_KEY="92375678801274567898123856780012"

export const encryptData = (data) => {
 try{
  const iv = CryptoJS.lib.WordArray.random(16);
  const key = CryptoJS.enc.Utf8.parse(SECRET_KEY);
//   const key = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_CRYPTO_SECRET_KEY);
  const encrypted = CryptoJS.AES.encrypt(
    JSON.stringify(data),
    key,
    {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    }
  );
  const encryptedString = `${CryptoJS.enc.Base64.stringify(iv)}:${encrypted.ciphertext.toString(CryptoJS.enc.Base64)}`;
  return encryptedString;
 }catch(error){
  console.error("Encryption failed:", error);
    return null;
 }
};
